import axios from 'axios';

const baseURL = process.env.VUE_APP_BASE_API;
const headers = {
  'content-type': 'application/json;charset=UTF-8',
};
export function getHomeMediaDetail(data) {
  const url = '/media/homeMediaDetail';
  return axios.get(url, {
    params: data,
    headers,
  }).then(res => Promise.resolve(res.data));
}

export function funQuestionList(data) {
  const url = `${baseURL}/funQuestion/page`;
  return axios.get(url, {
    params: data,
    headers,
  }).then(res => Promise.resolve(res.data));
}

export function funQuestiontopics(data) {
  const url = `${baseURL}/funQuestion/topics`;
  return axios.get(url, {
    params: data,
    headers,
  }).then(res => Promise.resolve(res.data));
}

export function funQuestionAnswer(data) {
  const url = `${baseURL}/funQuestion/answer`;
  return axios.get(url, {
    params: data,
    headers,
  }).then(res => Promise.resolve(res.data));
}
